// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('h4')`
  color: ${props => props.theme.iconText.title.color};
  font-size: ${props => props.theme.iconText.title.fontSize};
  margin: 0px;
  overflow: hidden;
  overflow-wrap: break-word;
`;
